<template>
  <span>
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 256 256" aria-hidden="true" :class="[svgClassName, 'select-none']"><path d="M212.24,100.24l-80,80a6,6,0,0,1-8.48,0l-80-80a6,6,0,0,1,8.48-8.48L128,167.51l75.76-75.75a6,6,0,0,1,8.48,8.48Z"></path></svg>
  </span>
</template>

<script>
  export default {
    name: "ArrowIcon",
    props: {
      svgClassName: {
        type: String,
        default: ""
      }
    }
  }
</script>